import { schema, types } from 'papr'

export const readingHistorySchema = schema({
	user: types.objectId({ required: true }),
	post: types.objectId({ required: true }),
	dateAdded: types.date({ required: true }),
})

export type ReadingHistoryDocument = (typeof readingHistorySchema)[0]
export type ReadingHistorySchemaOptions = (typeof readingHistorySchema)[1]
